/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.discovery.studio.rpc.PlacementsRpc
 */

export const CalloutPlacementTypename = 'com.hubspot.marketplace.discovery.studio.models.placements.CalloutPlacement';
export const CalloutPlacementDiscriminant = 'CALLOUT';
export const CalloutPlacementDiscriminantKey = 'entityType';
export const CollectionPlacementTypename = 'com.hubspot.marketplace.discovery.studio.models.placements.CollectionPlacement';
export const CollectionPlacementDiscriminant = 'COLLECTION';
export const CollectionPlacementDiscriminantKey = 'entityType';
export const PlacementDiscriminantKey = 'entityType';
export const getPlacementsRpc = {
  serviceName: 'com.hubspot.marketplace.discovery.studio.rpc.PlacementsRpc',
  rpcName: 'getPlacements',
  auth: 'external',
  fingerprint: 'XvdgxacOVTxdehBbrhu9h53WScrhxELO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};